// src/careReferral/components/payInvoiceDialog.tsx
import React from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Stack, Typography,
} from "@mui/material";
import PayInvoiceButtons from "./payInvoiceButtons";

export type MiniInvoice = { id: string; amount: number; leadId?: string | number };

export default function PayInvoiceDialog({
  open,
  invoice,
  onClose,
  onPaid,
  onCancel,
}: {
  open: boolean;
  invoice: MiniInvoice | null;
  onClose: () => void;
  onPaid: (paypalCaptureId: string) => void;
  onCancel?: () => void;
}) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Pay Invoice</DialogTitle>
      <DialogContent>
        {invoice ? (
          <Stack spacing={2} sx={{ mt: 1 }}>
            <Typography variant="body2" color="text.secondary">
              Invoice: <strong>{invoice.id}</strong> • Amount:{" "}
              <strong>${(invoice.amount ?? 0).toFixed(2)}</strong>
            </Typography>

            <PayInvoiceButtons
              amount={invoice.amount}
              leadId={invoice.leadId}
              seed={invoice.id}                      // used to build a unique invoice_id
              onCreated={() => {/* optional */}}
              onApproved={(captureId: string) => onPaid(captureId)}
              onError={() => onCancel?.()}
            />
          </Stack>
        ) : (
          <Typography>Loading…</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
